<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">

    <div v-if="util.bookExistInPoints(point.distributionPoint.id, book.id, booksFromCheckedOrRedeemByDistPoint) && !noBookExchange()">
        <v-layout align-space-around column justify-center>

            <v-list two-line>

                    <v-list-tile
                            @click="openDialog"
                            avatar>
                        <v-list-tile-avatar>
                            <v-icon color="primary" left>account_balance</v-icon>
                        </v-list-tile-avatar>

                        <v-list-tile-content>
                            <v-list-tile-title>{{point.distributionPoint.distributionPointName}}</v-list-tile-title>
                            <v-list-tile-sub-title>Διαθεσιμότητα: {{point.availability}}</v-list-tile-sub-title>
                        </v-list-tile-content>
                    </v-list-tile>

            </v-list>
        </v-layout>

        <v-layout justify-center row>
            <v-dialog max-width="600" persistent v-model="dialog" @keydown.esc="close">
                <v-card>
                    <v-card-title class="headline secondary white--text justify-center">
                        <v-icon left class="white--text">place</v-icon>
                        <b>Σημείο Διανομής</b></v-card-title>
                    <v-divider></v-divider>
                    <v-list dense class="mt-2">
                        <v-list-tile>

                            <v-flex xs6>
                                <v-list-tile-content><b>Διεύθυνση:</b></v-list-tile-content>
                            </v-flex>
                            <v-flex xs6>
                                <v-list-tile-content class="align-end">
                                    {{point.distributionPoint.distributionPointAddress}}
                                </v-list-tile-content>
                            </v-flex>



                        </v-list-tile>
                        <v-list-tile>
                            <v-list-tile-content><b>Τ.Κ.:</b></v-list-tile-content>
                            <v-list-tile-content class="align-end">{{point.distributionPoint.distributionPointZipCode}}
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile>
                            <v-list-tile-content><b>Email: </b></v-list-tile-content>
                            <v-list-tile-content class="align-end">{{point.distributionPoint.distributionPointEmail}}
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile>
                            <v-list-tile-content><b>Fax: </b></v-list-tile-content>
                            <v-list-tile-content class="align-end">{{point.distributionPoint.distributionPointFax}}
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile>
                            <v-list-tile-content><b>Σταθερό Τηλέφωνο: </b></v-list-tile-content>
                            <v-list-tile-content class="align-end">{{point.distributionPoint.distributionPointPhone}}
                            </v-list-tile-content>
                        </v-list-tile>

                        <v-list-tile>
                            <v-list-tile-content><b>Ωράριο Λειτουργίας:</b></v-list-tile-content>
                            <v-list-tile-content class="align-end">{{point.distributionPoint.distributionPointOpeningHours}}
                            </v-list-tile-content>
                        </v-list-tile>

                        <v-list-tile>
                            <v-list-tile-content><b>Σημείο στο Χάρτη: </b></v-list-tile-content>
                            <v-list-tile-content class="align-end "><i class="pointerCursor" @click="maps">{{this.distPointInfo.point}}</i>
                            </v-list-tile-content>
                        </v-list-tile>
                        <hr>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                    @click="close"
                                    color="primary darken-0">
                                Κλείσιμο
                            </v-btn>
                        </v-card-actions>
                    </v-list>
                </v-card>
            </v-dialog>
        </v-layout>
    </div>
</template>

<script>
    import CourierTypeComponent from "./ExchangeTypeComponent";
    import util from "../../utilities";

    export default {
        name: "StatementBookListComponent",
        components: {CourierTypeComponent},
        data() {
            return {
                util,
                dialog: false,
                distPointInfo: {
                    point: 'Πατήστε Εδώ'
                }
            }
        },
        props: {
            point: Object,
            index: Number,
            book: Object,
            booksFromCheckedOrRedeemByDistPoint: Array
        },
        methods: {
            openDialog() {
                this.dialog = true
                //var flag = true;
                //this.$store.commit('setDialog', flag)
            },
            closeDialog() {
                var flag = false;
                this.$store.commit('setDialog', flag)
            },
            close() {
                this.dialog = false;
            },
            maps() {
                // var url = 'http://www.google.com/maps/place/' + this.latitude + ',' + this.longtitude;
                var url = this.point.distributionPoint.distributionPointLocationURL;
                window.open(url, '_blank');

            },

            //check if book is exchange
            noBookExchange: function () {
                var bookGroups = this.$store.getters.active.bookGroups;

                if (bookGroups != undefined)
                    for (var i = 0; i < bookGroups.length; i++) {
                        if (bookGroups[i].books.length > 0) {
                            if (bookGroups[i].books[0].book.id == this.book.id) {
                                if (bookGroups[i].books[0].book.hasOwnProperty('exchangeSourceId')  && !bookGroups[i].books[0].book.delivered) {
                                    return true
                                }
                            }
                        }
                    }
                return false
            }
        }
    }
</script>

<style scoped>

</style>
